import { RouteConfig } from 'vue-router'

import {
  MEMBER_AREA_ROUTE_COMPANIONS,
  MEMBER_AREA_ROUTE_DELIVERIES,
  MEMBER_AREA_ROUTE_FORGOT_PASSWORD,
  MEMBER_AREA_ROUTE_HOMEPAGE,
  MEMBER_AREA_ROUTE_INFORMATIONS,
  MEMBER_AREA_ROUTE_LOGIN,
  MEMBER_AREA_ROUTE_MODIFY_PET_MENU,
  MEMBER_AREA_ROUTE_MODIFY_PET_SUBSCRIPTION,
  MEMBER_AREA_ROUTE_PAYMENTS,
  MEMBER_AREA_ROUTE_PETS,
  MEMBER_AREA_ROUTE_PET_PRODUCT,
  MEMBER_AREA_ROUTE_PET_PRODUCTS,
  MEMBER_AREA_ROUTE_PRODUCT,
  MEMBER_AREA_ROUTE_PRODUCTS,
  MEMBER_AREA_ROUTE_RESET_PASSWORD,
  MEMBER_AREA_ROUTE_SPONSORSHIP,
} from '@member-area/core/routes-names'

import PassThrough from '../components/PassThrough.vue'

export function importDefault(promise) {
  return promise.then((m) => m.default || m)
}

const routes: RouteConfig[] = [
  {
    path: '/',
    name: MEMBER_AREA_ROUTE_HOMEPAGE,
    component: () => importDefault(import('@member-area/pages/Home')),
    meta: {
      withAuth: true,
      i18nPages: [
        'items',
        'snoopy_companions',
        'snoopy_navbar',
        'breed',
        'breed_cat',
        'global',
        'upsell_products',
        'profile-builder-delivery',
      ],
    },
  },
  {
    path: '/companions/',
    name: MEMBER_AREA_ROUTE_COMPANIONS,
    redirect: { name: MEMBER_AREA_ROUTE_HOMEPAGE },
  },
  {
    path: '/payments/',
    name: MEMBER_AREA_ROUTE_PAYMENTS,
    component: () => importDefault(import('@member-area/pages/Payments')),
    meta: {
      withAuth: true,
      i18nPages: ['snoopy_navbar', 'snoopy_payments', 'global'],
    },
  },
  {
    path: '/login/',
    name: MEMBER_AREA_ROUTE_LOGIN,
    component: () => importDefault(import('@member-area/pages/Login')),
    meta: {
      i18nPages: ['snoopy_login', 'snoopy_form_validation', 'global'],
    },
  },
  {
    path: '/password/',
    component: () => importDefault(import('@member-area/pages/Password')),
    children: [
      {
        path: 'forgot/',
        name: MEMBER_AREA_ROUTE_FORGOT_PASSWORD,
        meta: {
          i18nPages: ['snoopy_password_forgot', 'global'],
        },
        component: () =>
          importDefault(
            import('@member-area/pages/Password/pages/ForgotPassword'),
          ),
      },
      {
        path: 'reset/:token/',
        name: MEMBER_AREA_ROUTE_RESET_PASSWORD,
        component: () =>
          importDefault(
            import('@member-area/pages/Password/pages/ResetPassword'),
          ),
        meta: {
          i18nPages: ['snoopy_password_reset', 'snoopy_form_validation'],
        },
      },
    ],
  },
  {
    path: '/informations/',
    name: MEMBER_AREA_ROUTE_INFORMATIONS,
    component: () => importDefault(import('@member-area/pages/Informations')),
    meta: {
      withAuth: true,
      i18nPages: [
        'snoopy_navbar',
        'snoopy_informations',
        'snoopy_form_validation',
        'global',
      ],
    },
  },
  {
    path: '/deliveries/',
    name: MEMBER_AREA_ROUTE_DELIVERIES,
    component: () => importDefault(import('@member-area/pages/Deliveries')),
    meta: {
      withAuth: true,
      i18nPages: [
        'snoopy_navbar',
        'snoopy_delivery',
        'snoopy_informations',
        'global',
      ],
    },
  },
  {
    path: '/products/',
    name: MEMBER_AREA_ROUTE_PRODUCTS,
    component: PassThrough,
    children: [
      {
        path: '/',
        name: MEMBER_AREA_ROUTE_PRODUCTS,
        props: ({ params }) => ({ id: Number(params.productId) }),
        component: () => importDefault(import('@member-area/pages/Products')),
        meta: {
          withAuth: true,
          i18nPages: [
            'upsell_products',
            'snoopy_navbar',
            'snoopy_products',
            'profile_builder_products',
            'items',
            'global',
          ],
        },
      },
      {
        path: ':productId/',
        name: MEMBER_AREA_ROUTE_PRODUCT,
        component: () => importDefault(import('@member-area/pages/Product')),
        props: ({ params }) => ({ productId: Number(params.productId) }),
        meta: {
          withAuth: true,
          i18nPages: [
            'profile-builder-recipe',
            'snoopy_navbar',
            'upsell_products',
            'snoopy_product',
            'global',
          ],
        },
      },
    ],
  },
  {
    path: '/pets/',
    component: PassThrough,
    name: MEMBER_AREA_ROUTE_PETS,
    children: [
      {
        path: ':id?/',
        name: MEMBER_AREA_ROUTE_PETS,
        component: () => importDefault(import('@member-area/pages/Pets')),
        props: ({ params }) => ({ id: Number(params.id) }),
        meta: {
          withAuth: true,
          i18nPages: [
            'global',
            'upsell_products',
            'breed_cat',
            'breed',
            'profile-builder-recipe',
          ],
        },
      },
      {
        path: ':id/products',
        name: MEMBER_AREA_ROUTE_PET_PRODUCTS,
        component: PassThrough,
        meta: {
          withAuth: true,
          i18nPages: [
            'upsell_products',
            'snoopy_navbar',
            'snoopy_products',
            'profile_builder_products',
            'items',
            'global',
          ],
        },
        children: [
          {
            path: '/',
            props: ({ params }) => ({ id: Number(params.id) }),
            name: MEMBER_AREA_ROUTE_PET_PRODUCTS,
            component: () =>
              importDefault(import('@member-area/pages/Products')),
            meta: {
              withAuth: true,
              i18nPages: [
                'upsell_products',
                'snoopy_navbar',
                'snoopy_products',
                'profile_builder_products',
                'items',
                'global',
              ],
            },
          },
          {
            path: ':productId/',
            name: MEMBER_AREA_ROUTE_PET_PRODUCT,
            component: () =>
              importDefault(import('@member-area/pages/Product')),
            props: ({ params }) => ({
              id: Number(params.id),
              productId: Number(params.productId),
            }),
            meta: {
              withAuth: true,
              i18nPages: [
                'profile-builder-recipe',
                'snoopy_navbar',
                'upsell_products',
                'snoopy_product',
                'global',
              ],
            },
          },
        ],
      },
      {
        path: ':id/modify',
        component: PassThrough,
        name: MEMBER_AREA_ROUTE_MODIFY_PET_SUBSCRIPTION,
        props: ({ params }) => ({ id: Number(params.id) }),
        children: [
          {
            path: '/',
            name: MEMBER_AREA_ROUTE_MODIFY_PET_SUBSCRIPTION,
            component: () =>
              importDefault(import('@member-area/pages/ModifyPets')),
            props: ({ params }) => ({ id: Number(params.id) }),
            meta: {
              withAuth: true,
              i18nPages: [
                'snoopy_navbar',
                'upsell_products',
                'snoopy_product',
                'global',
              ],
            },
          },
          {
            path: 'menu',
            name: MEMBER_AREA_ROUTE_MODIFY_PET_MENU,
            component: () => importDefault(import('@member-area/pages/Menu')),
            props: ({ params }) => ({ id: Number(params.id) }),
            meta: {
              withAuth: true,
              i18nPages: [
                'global',
                'upsell_products',
                'breed_cat',
                'breed',
                'profile-builder-recipe',
              ],
            },
          },
        ],
      },
    ],
  },
  {
    path: '/sponsorship/',
    name: MEMBER_AREA_ROUTE_SPONSORSHIP,
    component: () => importDefault(import('@member-area/pages/Sponsorship')),
    meta: {
      withAuth: true,
    },
  },
  {
    path: '*',
    redirect: { name: MEMBER_AREA_ROUTE_COMPANIONS },
  },
]

export default routes
